import { render, staticRenderFns } from "./push.vue?vue&type=template&id=722eca8e&scoped=true"
import script from "./push.vue?vue&type=script&lang=js"
export * from "./push.vue?vue&type=script&lang=js"
import style0 from "./push.vue?vue&type=style&index=0&id=722eca8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722eca8e",
  null
  
)

export default component.exports